var render = function render(_c,_vm){return _c('transition',{attrs:{"name":"slide-up","appear":"appear"}},[_c('div',{staticClass:"one-offline-notification"},[_vm._v("\n    "+_vm._s(_vm.parent.$t('offline'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }